import { ValueSaveRequestDto } from '../dto/request/value-save-request.dto';
import { ValueUpdateRequestDto } from '../dto/request/value-update-request.dto';
import { ValueResponseDto } from '../dto/response/value-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class BaselineService extends BaseLandscapeService {
  public async fetchBaselineById(id: string): Promise<ValueResponseDto> {
    const response = await this.get<ValueResponseDto>(`/baseline/${id}`);
    return response.data;
  }

  public async saveBaseline(
    saveRequest: ValueSaveRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.post<ValueResponseDto>(
      `/baseline`,
      saveRequest
    );
    return response.data;
  }

  public async updateBaseline(
    updateRequest: ValueUpdateRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.put<ValueResponseDto>(
      `/baseline`,
      updateRequest
    );
    return response.data;
  }

  public async updateVerificationLabel(
    updateRequest: ValueUpdateRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.put<ValueResponseDto>(
      `/baseline/putverificationlabel`,
      updateRequest
    );
    return response.data;
  }

  public async deleteBaseline(existingId: string): Promise<void> {
    await this.delete<void>(`/baseline/${existingId}`);
  }
}

const baselineService = new BaselineService();
export default baselineService;
